// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1TFPkYqAlOaaHW5U1_VJtJ","row":"_23zsHiTxN2x22ACcMAfb9O"};